import { Sex } from "/@/generated/graphql";

export const patientSexChoices = [
  { value: Sex.Female, label: "Femme" },
  { value: Sex.Male, label: "Homme" },
];
